import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import Dialog from '@mui/material/Dialog';

interface IModalProps {
	children: React.ReactNode;
	open: boolean;
	onClose?: () => void;
}

const Modal = ({ children, open, onClose }: IModalProps) => {
	return (
		<Dialog
			open={open}
			onClose={() => {
				if (onClose) onClose();
			}}
			sx={{
				'& .MuiDialog-container': {
					alignItems: { xs: 'flex-end', sm: 'center' },
				},
				'& .MuiPaper-root': {
					margin: 0,
					width: '100%',
					minWidth: { xs: '100%', sm: '473px' },
					borderRadius: { xs: 0, sm: '8px' },
					px: { xs: '24px', sm: '32px' },
					py: { xs: '48px', sm: '32px' },
				},
			}}
		>
			{onClose && (
				<IconButton
					aria-label='close dialog'
					onClick={onClose}
					sx={{
						position: 'absolute',
						right: '8px',
						top: '8px',
						color: 'common.black',
					}}
				>
					<CloseIcon />
				</IconButton>
			)}
			{children}
		</Dialog>
	);
};

export default Modal;
